/**
 * Keep theme modals above app FOMO / sales-notification toasts.
 * - Moves open modals to document.body (escapes parent stacking contexts)
 * - Temporarily hides other fixed toast-sized overlays while open
 */
(function () {
  const HEADER_SELS = 'header, .shopify-section-group-header-group, #shopify-section-header';
  const KEEP_VISIBLE = '.drawer, cart-drawer, .modal, modal-dialog, .skip-link, #shopify-chat, iframe#PreviewBarContainer';

  function isKeptVisible(el) {
    if (!el || el.nodeType !== 1) return true;
    if (el.matches?.(KEEP_VISIBLE) || el.closest?.(KEEP_VISIBLE)) return true;
    if (el.closest?.(HEADER_SELS)) return true;
    return false;
  }

  function hideCompetingOverlays(modal) {
    const hidden = [];
    document.querySelectorAll('body *').forEach((el) => {
      if (el === modal || modal.contains(el)) return;
      if (isKeptVisible(el)) return;

      const cs = window.getComputedStyle(el);
      if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
      if (cs.visibility === 'hidden' || cs.display === 'none' || Number(cs.opacity) === 0) return;

      const rect = el.getBoundingClientRect();
      if (rect.width < 40 || rect.height < 24) return;
      // Toast / sales-pop sized — not full-screen sheets
      if (rect.width > window.innerWidth * 0.7) return;
      if (rect.height > Math.min(280, window.innerHeight * 0.45)) return;

      hidden.push({
        el,
        visibility: el.style.visibility,
        opacity: el.style.opacity,
        pointerEvents: el.style.pointerEvents
      });
      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('opacity', '0', 'important');
      el.style.setProperty('pointer-events', 'none', 'important');
    });
    return hidden;
  }

  function restoreOverlays(hidden) {
    (hidden || []).forEach(({ el, visibility, opacity, pointerEvents }) => {
      if (visibility) el.style.visibility = visibility;
      else el.style.removeProperty('visibility');
      if (opacity) el.style.opacity = opacity;
      else el.style.removeProperty('opacity');
      if (pointerEvents) el.style.pointerEvents = pointerEvents;
      else el.style.removeProperty('pointer-events');
    });
  }

  function patchModal(Proto) {
    if (!Proto || Proto.__flModalLayerPatched) return;
    Proto.__flModalLayerPatched = true;

    const originalOpen = Proto.open;
    const originalClose = Proto.close;

    Proto.open = function openWithLayer(opener) {
      if (!this.__flHome) {
        this.__flHome = { parent: this.parentNode, next: this.nextSibling };
      }
      if (this.parentNode !== document.body) {
        document.body.appendChild(this);
      }

      document.documentElement.classList.add('fl-modal-open');
      restoreOverlays(this.__flHiddenOverlays);
      this.__flHiddenOverlays = hideCompetingOverlays(this);

      return originalOpen.call(this, opener);
    };

    Proto.close = function closeWithLayer() {
      const result = originalClose.call(this);

      restoreOverlays(this.__flHiddenOverlays);
      this.__flHiddenOverlays = [];
      document.documentElement.classList.remove('fl-modal-open');

      const home = this.__flHome;
      if (home?.parent && document.contains(home.parent)) {
        if (home.next && home.next.parentNode === home.parent) {
          home.parent.insertBefore(this, home.next);
        } else {
          home.parent.appendChild(this);
        }
      }

      return result;
    };
  }

  function apply() {
    const Ctor = customElements.get('modal-dialog');
    if (Ctor?.prototype) patchModal(Ctor.prototype);
  }

  if (customElements.get('modal-dialog')) {
    apply();
  } else {
    customElements.whenDefined('modal-dialog').then(apply);
  }
})();
